import request from '@/utils/request'

// 轮播管理 -- 列表
export function GetBannerList(data) {
    return request({
        url: '/front/banner/findBanners',
        method: 'POST',
        data: data
    })
}